import { Button, type ButtonProps } from '@components/Button.tsx';
import { type PropsWithChildren } from 'react';
import { classNames } from '@utils/classNames.ts';
import BaseModal, {
  type BaseModalProps,
} from '@components/modals/BaseModal.tsx';

export type DialogProps = PropsWithChildren<
  {
    open: boolean;
    setOpen: (open: boolean) => void;
    actions: { buttonProps: ButtonProps }[];
    actionContainerClassNames?: string;
    testId?: string;
    passthrough?: {
      panel?: { className?: string };
    };
  } & Partial<Omit<BaseModalProps, 'actions'>>
>;

export default function Dialog({
  open,
  setOpen,
  dismissible = true,
  title,
  children,
  actions,
  actionContainerClassNames,
  testId,
  ...rest
}: DialogProps) {
  return (
    <BaseModal
      {...rest}
      open={open}
      setOpen={setOpen}
      dismissible={dismissible}
      title={title}
      content={
        children ? (
          <div className={classNames('h-full text-sm', !dismissible && 'mt-2')}>
            {children}
          </div>
        ) : undefined
      }
      actions={
        actions.length > 0 ? (
          <div
            className={classNames(
              'mt-5 sm:mt-4 grid sm:grid-cols-2 grid-flow-row-dense gap-x-4 gap-y-2',
              actionContainerClassNames,
            )}
            style={{ direction: 'rtl' }}
          >
            {actions.map((action, index) => (
              <Button key={index} {...action.buttonProps} />
            ))}
          </div>
        ) : (
          <></>
        )
      }
      testId={testId}
    />
  );
}
